import React, { Fragment } from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import { StoryCard } from "./StoryCard";

import "./three-col-five-stories.m.css";

export const OtherStories = ({ showStorySeparator, otherStories, showTimeStamp, showReadTime, sectionSlug }) => {
  return (
    <>
      {otherStories.map((story, index) => {
        return (
          <Fragment key={index}>
            <StoryCard
              key={index}
              story={story}
              showTimeStamp={showTimeStamp}
              showReadTime={showReadTime}
              sectionSlug={sectionSlug}
            />
            {showStorySeparator && index !== otherStories.length - 1 && <div styleName="divider"></div>}
          </Fragment>
        );
      })}
    </>
  );
};

OtherStories.propTypes = {
  otherStories: PropTypes.array.isRequired,
  showStorySeparator: PropTypes.bool,
  showTimeStamp: PropTypes.bool,
  showReadTime: PropTypes.bool,
  isFirstSet: PropTypes.bool,
  sectionSlug: PropTypes.string,
};
